import { type FlowDocumentSearchBlock, FlowDocumentSearchBlockConfigSchema } from 'flow-schema';

import { DocumentSearchFormFields } from './FormFields';
import { documentSearchDocumentationMarkdown } from './documentation';
import { getDefaultDocumentSearchConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const documentSearchNodeConfig: BlockConfigProps<FlowDocumentSearchBlock['config']> = {
  defaultLabelPrefix: 'documentSearch',
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultConfig: getDefaultDocumentSearchConfig(),
  configFields: {
    schema: FlowDocumentSearchBlockConfigSchema,
    FormFields: DocumentSearchFormFields,
  },
  documentationMarkdown: documentSearchDocumentationMarkdown,
};
